<template>
    <v-app-bar v-if="preafi" app color="primary" dark class="ma-0 pa-0 rounded-0 elevation-0">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="goToHome">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
            <span>cerrar</span>
        </v-tooltip>
        <v-toolbar-title>Formulario</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex flex-column text-right">
            <div class="font-weight-regular">Nro. matrícula</div>
            <div class="font-weight-bold text-h5">{{ matricula }}</div>
        </div>
    </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    components: {

    },
    data() {
        return {

        }

    },
    computed: {
        ...mapGetters('preafiliacion', ['preafi', 'matricula']),
    },
    methods: {
        ...mapMutations('preafiliacion', ['setPreAfi']),
        ...mapActions('preafiliacion', ['borrarDatosAfiliacion']),


        goToHome() {
            this.setPreAfi(false)
            //this.borrarDatosAfiliacion()
            this.$router.push('/login').then(() => {
                location.reload()
            }).catch(() => { })
        },
    },

}
</script>
